import IconButton from "@material-ui/core/IconButton";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import React, { useState } from "react";
import { useHistory } from "react-router-dom";

import type { DashboardRole } from "./useGetDashboardEventRoles";

type AdminDashboardEventMenuProps = {
  eventId: string;
  eventName: string;
  roles: DashboardRole[];
  ticketIds: string[];
};

const createSalesDashboardPath = (eventId: string): string => {
  const searchParams = new URLSearchParams({ event_id: eventId });

  return `/admin/sales?${searchParams.toString()}`;
};

const createTicketDashboardPath = (
  eventName: string,
  ticketIds: readonly string[]
): string => {
  const searchParams = new URLSearchParams();
  ticketIds.forEach((ticketId) => {
    searchParams.append("ticket_id", ticketId);
  });
  searchParams.set("event_title", eventName);

  return `/admin/tickets?${searchParams.toString()}`;
};

export const AdminDashboardEventMenu: React.FC<
  AdminDashboardEventMenuProps
> = ({ eventId, eventName, roles, ticketIds }) => {
  const history = useHistory();
  const [anchorElement, setAnchorElement] = useState<HTMLButtonElement | null>(
    null
  );
  const canViewSalesDashboard = roles.includes("sales_dashboard_viewer");
  const canViewTicketDashboard =
    roles.includes("ticket_dashboard_viewer") && ticketIds.length > 0;
  const canOpenDashboardMenu = canViewSalesDashboard || canViewTicketDashboard;

  const handleOpenMenu = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorElement(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setAnchorElement(null);
  };

  const handleOpenSalesDashboard = () => {
    handleCloseMenu();
    history.push(createSalesDashboardPath(eventId));
  };

  const handleOpenTicketDashboard = () => {
    handleCloseMenu();
    history.push(createTicketDashboardPath(eventName, ticketIds));
  };

  return (
    <>
      <IconButton
        aria-label={`${eventName}の操作メニュー`}
        aria-haspopup="menu"
        disabled={!canOpenDashboardMenu}
        type="button"
        onClick={handleOpenMenu}
      >
        <MoreVertIcon aria-hidden="true" />
      </IconButton>

      {canOpenDashboardMenu && (
        <Menu
          anchorEl={anchorElement}
          open={Boolean(anchorElement)}
          onClose={handleCloseMenu}
        >
          {canViewSalesDashboard && (
            <MenuItem onClick={handleOpenSalesDashboard}>
              売上ダッシュボード
            </MenuItem>
          )}
          {canViewTicketDashboard && (
            <MenuItem onClick={handleOpenTicketDashboard}>
              チェックイン確認ダッシュボード
            </MenuItem>
          )}
        </Menu>
      )}
    </>
  );
};
